import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { DaliService } from '@dali/tagger-ng8';
import { EVENT as EVENT_FA_TC, PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
var ConfigurationValuesComponent = /** @class */ (function () {
    function ConfigurationValuesComponent(copyService, headerService, abrecuentasService, bitacoraService, navigationService, firmlyApprovedService, channelCommunicatorService, taggingService, daliService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.abrecuentasService = abrecuentasService;
        this.bitacoraService = bitacoraService;
        this.navigationService = navigationService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.taggingService = taggingService;
        this.daliService = daliService;
        this.err_msn = false;
        this.state_master = false;
        this.state_visa = false;
        this.state_visalf = false;
        this.state_next = true;
        this.config = {
            allowNegative: false,
            decimal: ',',
            precision: 0,
            thousands: '.',
            prefix: '$ ',
        };
        this.payDayProductModel = {
            selectedPayDay: {},
            selectedProduct: {},
        };
        this.firmlyApproved = false;
        this.headerService.show(true, true, true);
        this.firmlyApproved = !this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme';
        this.setPayDayProductModel();
        this.get_ConfigurationValues();
    }
    /**
     * Se inicializa el formulario en vacío, solo se validan los valores mínimos de cada uno.
     */
    ConfigurationValuesComponent.prototype.ngOnInit = function () {
        if (this.firmlyApprovedService.isFirmlyApproved() && this.abrecuentasService.getProductsSelects().length === 1) {
            this.sendConfigurationValuesPageLoad();
        }
        this.formValues = new FormGroup({});
        if (this.state_master) {
            this.formValues.addControl('value_master', new FormControl(this.value_master, [Validators.required, Validators.min(1000000)]));
        }
        if (this.state_visa) {
            this.formValues.addControl('value_visa', new FormControl(this.value_visa, [Validators.required, Validators.min(1000000)]));
        }
        if (this.state_visalf) {
            this.formValues.addControl('value_visalf', new FormControl(this.value_visalf, [Validators.required, Validators.min(2000000)]));
        }
        this.enableNextButton();
    };
    /**
     * Se capturan el monto aprobado y se activan las franquicias seleccionadas para distribuir el monto entre ellas.
     */
    ConfigurationValuesComponent.prototype.setPayDayProductModel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, product, pcoModel, listProductos;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.abrecuentasService.getPayDayProductSelected()];
                    case 1:
                        _a.payDayProductModel = _b.sent();
                        if (!this.firmlyApproved) return [3 /*break*/, 2];
                        product = this.firmlyApprovedService.getProduct_FirmlyApproved(BUSINESS_CONST.PRODUCT_CODE_TCR);
                        this.max_value = product ? parseInt(product.amount, 10) : 0;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.abrecuentasService.getPcoModel()];
                    case 3:
                        pcoModel = _b.sent();
                        console.log(pcoModel);
                        if (this.abrecuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                            this.max_value = parseInt(pcoModel.granted_product.limit_amount.amount.toString(), 0);
                        }
                        if (this.abrecuentasService.getproductSelected().product_type === BUSINESS_CONST.MULTI) {
                            pcoModel.granted_product_multi.forEach(function (element) {
                                if (element.product_type === 'creditCard') {
                                    _this.max_value = parseInt(element.limit_amount.amount.toString(), 0);
                                }
                            });
                        }
                        _b.label = 4;
                    case 4:
                        if (Object.entries(this.payDayProductModel).length === 0) {
                            this.payDayProductModel = {
                                selectedPayDay: {},
                                selectedProduct: {},
                            };
                        }
                        else {
                            listProductos = this.payDayProductModel['selectedProduct'];
                            listProductos.forEach(function (element) {
                                if (element.elementId === 1) {
                                    _this.state_master = true;
                                }
                                else if (element.elementId === 2) {
                                    _this.state_visa = true;
                                }
                                else if (element.elementId === 3) {
                                    _this.state_visalf = true;
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigurationValuesComponent.prototype.get_ConfigurationValues = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var configValuesModel;
            return tslib_1.__generator(this, function (_a) {
                configValuesModel = this.abrecuentasService.getConfigurationValues();
                this.value_master = configValuesModel['value_master']
                    ? parseInt(configValuesModel['value_master'].toString(), 0)
                    : 0;
                this.value_visa = configValuesModel['value_visa']
                    ? parseInt(configValuesModel['value_visa'].toString(), 0)
                    : 0;
                this.value_visalf = configValuesModel['value_visalf']
                    ? parseInt(configValuesModel['value_visalf'].toString(), 0)
                    : 0;
                return [2 /*return*/];
            });
        });
    };
    /**
     * se capturan el monto aprobado y se activan las franquicias seleccionadas para distribuir el monto entre ellas.
     * La sumatoria de los cupos por franquicia no debe estar por encima, ni por debajo del cupo aprobado por PCO o
     * modificado por el cliente, en caso de que el valor difiera debe mostrar mensaje de error y el call to action
     * continuar debe estar deshabilitado
     */
    ConfigurationValuesComponent.prototype.enableNextButton = function () {
        var sum = (this.formValues.value['value_visa']
            ? parseInt(this.formValues.value.value_visa, 0)
            : 0) +
            (this.formValues.value['value_master']
                ? parseInt(this.formValues.value['value_master'], 0)
                : 0) +
            (this.formValues.value['value_visalf']
                ? parseInt(this.formValues.value['value_visalf'], 0)
                : 0);
        this.abrecuentasService.setConfigurationValues(this.formValues.value);
        if (sum === this.max_value && this.formValues.valid) {
            this.err_msn = false;
            this.state_next = false;
            return;
        }
        if (sum === this.max_value && !this.formValues.valid) {
            this.err_msn = false;
            this.state_next = true;
            return;
        }
        if (sum !== this.max_value && this.formValues.invalid) {
            this.err_msn = false;
            this.state_next = true;
            return;
        }
        if (sum !== this.max_value && !this.formValues.invalid) {
            this.err_msn = true;
            this.state_next = true;
        }
    };
    /**
     * Se guardar marcas en bitácora y se genera la navegación  al siguiente componente
     */
    ConfigurationValuesComponent.prototype.next = function () {
        var _this = this;
        if (this.taggingService.isFirmlyAprovedMono()) {
            this.sendContinueButtonEvent();
        }
        this.payDayProductModel['selectedProduct'].forEach(function (element) {
            if (element.elementId === 1) {
                _this.bitacoraService.saveDataInBitacora('value_master_' + _this.formValues.value['value_master'].toString());
                _this.setValues_FirmlyApproved(BUSINESS_CONST.MASTERCARD, parseInt(_this.formValues.value['value_master'], 10));
            }
            else if (element.elementId === 2) {
                _this.bitacoraService.saveDataInBitacora('value_visa_' + _this.formValues.value['value_visa'].toString());
                _this.setValues_FirmlyApproved(BUSINESS_CONST.VISA, parseInt(_this.formValues.value['value_visa'], 10));
            }
            else if (element.elementId === 3) {
                _this.bitacoraService.saveDataInBitacora('value_visalf_' + _this.formValues.value['value_visalf'].toString());
                _this.setValues_FirmlyApproved(BUSINESS_CONST.VISALM, parseInt(_this.formValues.value['value_visalf'], 10));
            }
        });
        this.abrecuentasService.setConfigurationValues(this.formValues.value);
        console.log('Configuration values: ', this.abrecuentasService.getConfigurationValues());
        this.navigationService.nextStep('200');
    };
    /**
     * Función que permite modificar los montos para cada una de las
     * franquincias seleccionadas por el usuario y que son de TCR del
     * Aprobado En Firme
     */
    ConfigurationValuesComponent.prototype.setValues_FirmlyApproved = function (brand, value) {
        if (!this.firmlyApproved) {
            return;
        }
        this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC).find(function (card) { return card.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC && card.brand === brand; }).limit_amount.amount = value;
        console.log('Valores del Aprobado TC: ', this.firmlyApprovedService.getDetailProductsMulti());
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    ConfigurationValuesComponent.prototype.sendConfigurationValuesPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var productsType = {
            ORD: 'LD',
            TCR: 'TC',
        };
        var changes = [
            {
                path: PAGEVIEW_FA.pv10pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv10pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv10pageFamily.path,
                value: PAGEVIEW_FA.pv10pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv10subFamily.path,
                value: PAGEVIEW_FA.pv10subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv10pageAction.path,
                value: PAGEVIEW_FA.pv10pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv10pageid.path,
                value: ConfigurationValuesComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv10transactionName.path,
                value: "" + PAGEVIEW_FA.pv10transactionName.value.slice(0, -2) + productsType[this.abrecuentasService.getProductsSelects()[0].product],
            },
            {
                path: PAGEVIEW_FA.pv10transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv10transactionTransactionStep.value,
            },
        ];
        this.taggingService.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* -------------- Taggeo - Events ------------- */
    ConfigurationValuesComponent.prototype.sendBackButtonEvent = function () {
        if (!this.taggingService.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_TC.pv10E1setData.pv10E1transactionTransactionStep.path,
                value: EVENT_FA_TC.pv10E1setData.pv10E1transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_TC.pv10E1setData.pv10E1transactionName.path,
                value: EVENT_FA_TC.pv10E1setData.pv10E1transactionName.value,
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_TC.customCategory.module.body,
                type: EVENT_FA_TC.customCategory.type.button,
                position: EVENT_FA_TC.customCategory.position.center,
            },
            action: EVENT_FA_TC.customAction.click,
            label: EVENT_FA_TC.pv10E1customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    ConfigurationValuesComponent.prototype.sendContinueButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_TC.pv10E2setData.pv10E2transactionTransactionStep.path,
                value: EVENT_FA_TC.pv10E2setData.pv10E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_TC.pv10E2setData.pv10E2transactionName.path,
                value: EVENT_FA_TC.pv10E2setData.pv10E2transactionName.value,
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_TC.customCategory.module.body,
                type: EVENT_FA_TC.customCategory.type.button,
                position: EVENT_FA_TC.customCategory.position.center,
            },
            action: EVENT_FA_TC.customAction.click,
            label: EVENT_FA_TC.pv10E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    return ConfigurationValuesComponent;
}());
export { ConfigurationValuesComponent };
